<script setup lang="ts">
import { computed } from 'vue';
import { useStateStore } from 'composables/useStateStore';

const stateStore = useStateStore();

// Group state by prop.type
const groupedState = computed(() => {
  const groups: Record<string, any[]> = {};
  for (const [key, prop] of Object.entries(stateStore.state)) {
    const type = prop.type || 'unknown';
    if (!groups[type]) groups[type] = [];
    groups[type].push({ key, prop });
  }
  return groups;
});
</script>

<template>
  <e-accordion>
    <e-accordion-item
      v-for="(props, type) in groupedState"
      :key="type"
      size="sm"
      :value="type"
    >
      <e-accordion-header slot="header">
        <e-accordion-trigger>{{ type }}</e-accordion-trigger>
      </e-accordion-header>
      <e-accordion-content slot="content">
        <div
          v-for="{ key, prop } in props"
          :key="key"
          class="flex flex-col gap-4"
        >
          <e-heading>
            <span>UID:</span> {{ prop.uid }} &nbsp; <span>Type:</span> {{ prop.type }} &nbsp;
            <span>Parent:</span> {{ prop.parent ?? '—' }}
          </e-heading>
          <table
            v-if="prop.props && prop.props.length !== 0"
            class="table-auto"
          >
            <thead>
              <tr>
                <th class="text-left">Prop</th>
                <th class="text-left">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, propName) in prop.props"
                :key="propName"
              >
                <td>{{ propName }}</td>
                <td>
                  {{ typeof value === 'object' ? JSON.stringify(value) : value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </e-accordion-content>
    </e-accordion-item>
  </e-accordion>
</template>
